import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { studyLabManagementServices } from "../../../../APIServices/studyLabManagementServices";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studySiteManagementServices } from "../../../../APIServices/studySiteManagementServices";
import SplitPane from "react-split-pane";
import Swal from "sweetalert2";
import LabManagementProperties from "../LabManagementProperties/LabManagementProperties";
import UpdateLabManagement from "./UpdateLabManagement";
import DeletedLabManagement from "./DeletedLabManagement";
import TableProperties from "../LabManagementProperties/TableProperties";
import LabManagementActivities from "../LabManagementProperties/LabManagementActivities";
import UseToggle from "../../../../Hooks/UseToggle";
import AddLabManagementForm from "./AddLabManagementForm";
import Pagination from "../../../Pagination";


const LabManagementDataList = ({ onMouseDown, tableRef }) => {
  const [searchData, setSearchData] = useState("");
  const [rowId, setRowId] = useState("");
  const [rowData, setRowData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [activityLoader, setActivityLoader] = useState(false);
  const [activeTab, setActiveTab] = useState("properties");
  const [labManagementColumns, setLabManagementColumns] = useState([]);
  const [labManagementColumnsCount, setLabManagementColumnsCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [labManagementRows, setLabManagementRows] = useState([]);
  const [labManagementRowsCount, setLabManagementRowsCount] = useState(0);
  const [labManagementDeletedRows, setLabManagementDeletedRows] = useState([]);
  const [labManagementDeletedRowsCount, setLabManagementDeletedRowsCount] = useState(0);
  const [labManagementActivity, setLabManagementActivity] = useState([]);
  const [labManagementActivityCount, setLabManagementActivityCount] = useState(0);
  const [siteUniqueId, setSiteUniqueId] = useState("");
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } =
    UseToggle();
  const [loading, setLoading] = useState(false);
  let { studyId } = useParams();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const ctmsPermission = JSON.parse(localStorage.getItem("ctmsPermissionData"));
  const [buttonLoader, setButtonLoader] = useState(false);

  const [siteId, setSiteId] = useState("");
  const [siteList, setSiteList] = useState([]);

  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const role = JSON.parse(localStorage.getItem("role"));

  let modifiedMode = StudyMode === "SDV QC Mode" ? "QC" : StudyMode === "SDV QC Mode" ? "QC" : StudyMode === "SDV Live Mode" ? "LIVE" : StudyMode === "Live Mode" ? "LIVE" : StudyMode === "DBP Mode" && "DBP"

  const handleDragEnd = async (result) => {
    if (!result.destination) return;
    const reordered = [...labManagementRows];
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    const indexing = reordered?.map((item, index) => ({
      testId: item.testId,
      index: index,
    }));
    let userData = {
      studyId: studyId,
      type: "studyLabManagement",
      indexing: indexing,
    };
    let resultIndex = await studyOtherSettingsServices.updateTableIndexing(
      userData
    );
    if (resultIndex?.statusCode === 200) {
      setLabManagementRows(reordered);
    }
  };

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const getStudySiteBasedonAccess = async () => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(studyId, StudyMode)
    let sites = data?.data || []
    setSiteList(sites)
    setSiteId(sites[0]?.siteId)
  }

  const getStudyLabManagementColumnData = async (e) => {
    setLoading(true);
    let data =
      await studyLabManagementServices.getStudyLabManagementColumnData(
        "active",
        studyId
      );
    setLabManagementColumns(data?.data || []);
    setLabManagementColumnsCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(labManagementRowsCount / itemsPerPage);

  const getStudyLabManagementRowData = async (e) => {
    setLoading(true);
    let data = await studyLabManagementServices.getStudyLabManagementRowData(
      "active",
      studyId,
      siteId,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setLabManagementRows(data?.data || []);
    setLabManagementRowsCount(data?.count || 0);
    setRowData("");
    setRowId("");
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedStudyLabManagementRowData = async (
    siteUniqueId,
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await studyLabManagementServices.getStudyLabManagementRowData(
      "deleted",
      studyId,
      siteUniqueId || siteId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setLabManagementDeletedRows(data?.data || []);
    setLabManagementDeletedRowsCount(data?.count || 0);
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData(
      "studyLabManagement",
      studyId
    );
    setTableColumns(data?.data || []);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "labManagementData",
      studyId,
      rowData?.testId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    let result = data?.data || []
    let updateData = result?.filter(item => item.actionType === "update")
    let otherData = result?.filter(item => item.actionType !== "update")?.length
    setLabManagementActivity(updateData);
    setLabManagementActivityCount((data?.count || 0) - otherData);
    setActivityLoader(false);
  };

  useEffect(() => {
    getStudyLabManagementColumnData();
    getTablePropertiesData();
  }, []);

  useEffect(() => {
    if (studyId) {
      getStudySiteBasedonAccess();
    }
  }, [studyId]);

  useEffect(() => {
    getStudyLabManagementRowData();
  }, [siteId, searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreStudyLabManagementRow = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} test!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = id;
        userData.studyId = studyId;
        userData.type = type;
        let data =
          await studyLabManagementServices.softDeleteRestoreStudyLabManagementRow(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyLabManagementRowData();
          getDeletedStudyLabManagementRowData(
            siteUniqueId,
            pageNumberDeleted,
            itemsPerPageDeleted
          );
          setRowId("");
          if (type === "restore") {
            getDeletedStudyLabManagementRowData(
              siteUniqueId,
              pageNumberDeleted,
              itemsPerPageDeleted
            );
            setToggle1();
          }
        }
      }
    });
  };

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.studyId = studyId;
        userData.type = "studyLabManagement";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyLabManagementRowData();
          getTablePropertiesData();
        }
      }
      setButtonLoader(false);
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          {!ctmsPermission.ctmsReadOnlyAccess && role === "ctms" && (
            <>
              <i
                title={isFormOpen ? "Close Form" : "Add Lab"}
                onClick={() => {
                  setIsFormOpen(!isFormOpen);
                  setRowId("");
                }}
                className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
                  }`}
              />
              <div className="vr"></div>
            </>
          )}
          {labManagementRowsCount > 0 && (
            <>
              <div className="position-relative">
                <Form.Control
                  type="Search"
                  onChange={(e) => setSearchData(e.target.value)}
                  value={searchData}
                  placeholder="Search..."
                  style={{ width: 200, padding: "3px 10px" }}
                ></Form.Control>
                <CiSearch
                  className="CP position-absolute bg-white"
                  title="Search"
                  style={{ width: 15, top: 4, right: 7 }}
                />
              </div>
              <div className="vr"></div>
            </>
          )}
          <Form.Select
            value={siteId}
            style={{ width: 150, padding: "3px 10px" }}
            onChange={(e) => setSiteId(e.target.value)}
          >
            <option value="" hidden>
              Select Site
            </option>
            {siteList.map((item, index) => (
              <option key={index} value={item.siteId}>
                {item.row?.SITEID}
              </option>
            ))}
          </Form.Select>
        </div>
        <div className="hstack gap-2">
          {labManagementRowsCount > 0 && (
            <button
              onClick={() => {
                setToggle2();
                getTablePropertiesData();
              }}
              className={`updateProfile`}
              style={{ fontSize: 12 }}
            >
              Table Properties
            </button>
          )}
          {role === "ctms" && !ctmsPermission.ctmsReadOnlyAccess && (
            <button
              onClick={() => {
                setToggle1();
                getDeletedStudyLabManagementRowData(
                  siteUniqueId,
                  pageNumberDeleted,
                  itemsPerPageDeleted
                );
              }}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          )}
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 179px)" }}
        minSize={rowId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddLabManagementForm
              getStudyLabManagementRowData={getStudyLabManagementRowData}
            />
          )}
          {loading ? (
            <PageLoader/>
          ) : labManagementRowsCount === 0 ? (
            <NoDataFoundTable MSG={"Lab management data not Found!"} />
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    {labManagementColumns?.map(
                      (column, index) =>
                        role === "ctms" ?
                          !(column?.columnName === "UPPERRANGE" || column?.columnName === "LOWERRANGE") &&
                          !tableColumns[column?.columnName] && (
                            <th onMouseDown={(e) => onMouseDown(e, index + 1)}>
                              {column?.columnLabel}
                            </th>
                          )
                          :
                          !tableColumns[column?.columnName] && (
                            <th onMouseDown={(e) => onMouseDown(e, index + 1)}>
                              {column?.columnLabel}
                            </th>
                          )
                    )}
                    {!ctmsPermission.ctmsReadOnlyAccess && (
                      <>
                        {role !== "ctms" &&
                          <th
                            onMouseDown={(e) =>
                              onMouseDown(e, labManagementColumnsCount + 2)
                            }
                            style={{ width: 45 }}
                            className="text-center"
                          >
                            Edit
                          </th>
                        }
                        {role === "ctms" &&
                          <th
                            onMouseDown={(e) =>
                              onMouseDown(e, labManagementColumnsCount + 3)
                            }
                            style={{ width: 55 }}
                            className="text-center"
                          >
                            Delete
                          </th>
                        }
                      </>
                    )}
                  </tr>
                </thead>
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="tableBody" type="ROW">
                    {(provided) => (
                      <tbody
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        {labManagementRows?.map((row, index) => (
                          <Draggable
                            key={row._id}
                            draggableId={row._id}
                            index={index}
                            isDragDisabled={ctmsPermission.ctmsReadOnlyAccess}
                          >
                            {(provided, snapshot) => (
                              <tr
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                key={index}
                                className={`CP ${rowData?._id === row?._id ? "highlighted" : ""
                                  } ${snapshot.isDragging ? "highlighted" : ""}`}
                                title="View Details"
                                onClick={() => setIsFormOpen(false)}
                              >
                                <td className="text-center">
                                  {index + 1 + startIndex}
                                </td>
                                {labManagementColumns?.map(
                                  (column, i) =>
                                    role === "ctms" ? !(column?.columnName === "UPPERRANGE" || column?.columnName === "LOWERRANGE") &&
                                      !tableColumns[column?.columnName] && (
                                        <td
                                          onClick={(e) => {
                                            {
                                              setRowData(row);
                                              setRowId(row?._id);
                                            }
                                          }}
                                          key={i}
                                        >
                                          {row?.row[column?.columnName] || ""}
                                        </td>
                                      )
                                      :
                                      !tableColumns[column?.columnName] && (
                                        <td
                                          onClick={(e) => {
                                            {
                                              setRowData(row);
                                              setRowId(row?._id);
                                            }
                                          }}
                                          key={i}
                                        >
                                          {column?.columnName === "LOWERRANGE" ? row?.row.LOWERRANGE || "" : column?.columnName === "UPPERRANGE" ? row?.row.UPPERRANGE || "" : row?.row[column?.columnName] || ""}
                                        </td>
                                      )
                                )}
                                {!ctmsPermission.ctmsReadOnlyAccess && (
                                  <>
                                    {role !== "ctms" &&
                                      <td
                                        title="Update"
                                        className="text-uppercase text-center CP"
                                        onClick={(e) => {
                                          setRowData(row);
                                          setToggle();
                                          e.stopPropagation();
                                        }}
                                        style={{ pointerEvents: "auto" }}
                                      >
                                        <FaEdit className="text-muted" />
                                      </td>
                                    }
                                    {role === "ctms" &&
                                      <td
                                        className="text-center CP"
                                        title="Delete"
                                        onClick={(e) => {
                                          softDeleteRestoreStudyLabManagementRow(
                                            row?._id,
                                            "delete"
                                          );
                                          e.stopPropagation();
                                        }}
                                        style={{ pointerEvents: "auto" }}
                                      >
                                        <FaTrash className="text-danger" />
                                      </td>
                                    }
                                  </>
                                )}
                              </tr>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </tbody>
                    )}
                  </Droppable>
                </DragDropContext>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={labManagementRowsCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {rowId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["properties", "test Activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setRowId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "properties" && (
              <LabManagementProperties
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                rowData={rowData}
              />
            )}
            {activeTab === "test Activities" && (
              <LabManagementActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                labManagementActivity={labManagementActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                rowData={rowData}
                labManagementActivityCount={labManagementActivityCount}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateLabManagement
        Show={!toggle}
        Hide={setToggle}
        rowData={rowData}
        setRowId={setRowId}
        labManagementColumns={labManagementColumns}
        getStudyLabManagementRowData={getStudyLabManagementRowData}
        Title={"Update Range"}
        modifiedMode={modifiedMode}
      />
      <TableProperties
        Show={!toggle2}
        Hide={setToggle2}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        labManagementColumns={labManagementColumns}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        buttonLoader={buttonLoader}
        updateTableProperties={updateTableProperties}
        role={role}
      />
      <DeletedLabManagement
        Show={!toggle1}
        Hide={setToggle1}
        studyId={studyId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        siteList={siteList}
        labManagementDeletedRows={labManagementDeletedRows}
        getDeletedStudyLabManagementRowData={getDeletedStudyLabManagementRowData}
        labManagementDeletedRowsCount={labManagementDeletedRowsCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        setSiteUniqueId={setSiteUniqueId}
        siteUniqueId={siteUniqueId}
        softDeleteRestoreStudyLabManagementRow={softDeleteRestoreStudyLabManagementRow}
        Title={"Deleted Test History"}
      />
    </>
  );
};

export default LabManagementDataList;
